import request from "@/utils/request";

export function getBankList() {
  return request({ url: "/user/bank/list", method: "get" });
}

export function getList() {
  return request({ url: "/user/bankCard/list", method: "post" });
}

export function save(data) {
  return request({ url: "/user/bankCard/save", method: "post", data: data });
}

export function del(id) {
  return request({ url: `/user/bankCard/${id}/delete`, method: "post" });
}
